var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDaiStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_20845_570)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.446 3.72l1.79-3.322a.745.745 0 011.317 0l1.789 3.323 3.267 1.82a.77.77 0 010 1.34L32.342 8.7l-1.79 3.322a.745.745 0 01-1.317 0l-1.789-3.322-3.267-1.82a.77.77 0 010-1.34l3.267-1.82zM9.657 14.037l4.72-8.772a1.966 1.966 0 013.48 0l4.72 8.772 8.624 4.801c1.376.764 1.376 2.775 0 3.54l-8.625 4.8-4.72 8.773a1.966 1.966 0 01-3.48 0l-4.72-8.772-8.624-4.802c-1.376-.764-1.376-2.774 0-3.539l8.625-4.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_20845_570"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v37H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiStar);
export default __webpack_public_path__ + "static/media/dai-star.05f341f5.svg";
export { ForwardRef as ReactComponent };